import React, { useEffect } from "react";
import { useSetState } from "utils/functions.utils";
import { Input, OutsideClickHandlerComponent } from "utils/imports.utils";
import "./color_picker.component.scss";
import { TwitterPicker, SketchPicker } from "react-color";
import { ColorPickerTypes, InputTypes } from "utils/interface.utils";

interface IColorPickerProps {
    color:string
    onSelect:Function
    type:ColorPickerTypes
    width?:string
    colors?:string[]
    pickerStyle?:React.CSSProperties
}

const ColorPicker = (props:IColorPickerProps) => {
    const [state, setState] = useSetState({ showColorPicker: false, color:props.color });

    useEffect(() => {
        setState({ color: props.color });
        // eslint-disable-next-line
    }, [props.color]);

    return (
        <OutsideClickHandlerComponent onOutsideClick={() => setState({ showColorPicker: false })}>
            <div className="color_box_container">
                <div className="color_box_input_container">
                    <div className="color_box_input">
                        <Input
                            type="text"
                            value={state.color}
                            onChange={event => {
                                setState({ color: event.target.value });
                                props.onSelect(event.target.value);
                            }}
                            variant={InputTypes.COLOR_PICKER}
                            containerStyle={{height:"36px"}}
                        />
                    </div>
                    <div className="color_box" style={{ backgroundColor: props.color }} onClick={() => setState({ showColorPicker: !state.showColorPicker })} />
                </div>
                {state.showColorPicker && props.type === ColorPickerTypes.TWITTER && (
                    <div className="color_picker">
                        <TwitterPicker
                            triangle="hide"
                            width={props.width}
                            colors={props.colors}
                            color={props.color}
                            onChange={color => {
                                setState({ color: color.hex });
                                props.onSelect(color.hex);
                            }}
                        />
                    </div>
                )}
                {state.showColorPicker && props.type === ColorPickerTypes.SKETCH && (
                    <div className="color_picker" style={props.pickerStyle}>
                        <SketchPicker
                            width={props.width}
                            colors={props.colors}
                            color={props.color}
                            onChange={color => {
                                setState({ color: color.hex });
                                props.onSelect(color.hex);
                            }}
                        />
                    </div>
                )}
            </div>
        </OutsideClickHandlerComponent>
    );
};

export default ColorPicker;